function isMobile() {
  const userAgent = navigator.userAgent || navigator.vendor;

  // Check for common mobile platforms
  if (/android/i.test(userAgent)) {
    return true; // Android
  }

  if (/iPhone|iPad|iPod/i.test(userAgent)) {
    return true; // iOS
  }

  // Check for other mobile platforms like Windows Phone
  if (/windows phone/i.test(userAgent)) {
    return true; // Windows Phone
  }

  return false; // Not a mobile device
}

export default isMobile;
